import { render, staticRenderFns } from "./FrailtyMeasurements.vue?vue&type=template&id=21702607&scoped=true"
import script from "./FrailtyMeasurements.vue?vue&type=script&lang=js"
export * from "./FrailtyMeasurements.vue?vue&type=script&lang=js"
import style0 from "./FrailtyMeasurements.vue?vue&type=style&index=0&id=21702607&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21702607",
  null
  
)

export default component.exports